(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ec-management', {
            parent: 'admin',
            url: '/ec-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Equipes commerciales'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/ec-management/ec-management.html',
                    controller: 'EquipeCommercialeManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })



        .state('ec-management.new', {
            parent: 'ec-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/ec-management/ec-management-dialog.html',
                    controller: 'EquipeCommercialeManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, name: null, user: null, maxUsers: 0, creditValue: 0,
                                creditsSpent: 0, credits: 0, organisation: null, dgs: new Array(5), oauth2: false
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ec-management', null, { reload: true });
                }, function() {
                    $state.go('ec-management');
                });
            }]
        })
        .state('ec-management.edit', {
            parent: 'ec-management',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/ec-management/ec-management-dialog.html',
                    controller: 'EquipeCommercialeManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EquipeCommerciale', function(EquipeCommerciale) {
                            var ec = EquipeCommerciale.get({id : $stateParams.id});
                            var dgs = new Array(5);
                            if (ec.dgs && ec.dgs[0]){
                                dgs[0] = ec.dgs[0];
                            }
                            if (ec.dgs && ec.dgs[1]){
                                dgs[1] = ec.dgs[1];
                            }
                            if (ec.dgs && ec.dgs[2]){
                                dgs[2] = ec.dgs[2];
                            }
                            if (ec.dgs && ec.dgs[3]){
                                dgs[3] = ec.dgs[3];
                            }
                            if (ec.dgs && ec.dgs[4]){
                                dgs[4] = ec.dgs[4];
                            }
                            ec.dgs = ec;
                            return ec;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ec-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ec-management.delete', {
            parent: 'ec-management',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/ec-management/ec-management-delete-dialog.html',
                    controller: 'EquipeCommercialeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EquipeCommerciale', function(EquipeCommerciale) {
                            return EquipeCommerciale.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('ec-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
